"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateUnifiedOrderDataAdapter = exports.validateMailchimp = exports.validateForm = exports.validateCheckboxField = exports.validateAll = exports.default = void 0;
var _constants = require("./constants");
var _errorHandlerUtility = _interopRequireDefault(require("./utils/errorHandlerUtility"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var fileName = 'validations.js';
var validateForm = (data, entryID) => {
  // Check the root level node is a form
  var isForm = 'type' in data && data.type === _constants.FIELD_TYPES.FORM_CONTENT_TYPE;
  if (!isForm) {
    _errorHandlerUtility.default.report(JSON.stringify({
      entryID: entryID,
      message: "Invalid root node; must be of type: ".concat(_constants.FIELD_TYPES.FORM_CONTENT_TYPE),
      fileName,
      methodName: 'validateForm'
    }));
    throw new Error("Invalid root node; must be of type: ".concat(_constants.FIELD_TYPES.FORM_CONTENT_TYPE));
  }

  // Ensure there is a 'fields' key in data of type array, otherwise will break rendering
  var hasFields = 'fields' in data && data.fields instanceof Array;
  if (!hasFields) {
    _errorHandlerUtility.default.report(JSON.stringify({
      entryID: entryID,
      message: 'Invalid or missing form fields',
      fileName,
      methodName: 'validateForm'
    }));
    throw new Error('Invalid or missing form fields');
  }

  // Ensure the form ID matches what we requested
  var hasValidID = 'id' in data && data.id === entryID;
  if (!hasValidID) {
    _errorHandlerUtility.default.report(JSON.stringify({
      entryID: entryID,
      message: "Invalid form ID; expected ".concat(entryID, " but received ").concat(data.id),
      fileName,
      methodName: 'validateForm'
    }));
    throw new Error("Invalid form ID; expected ".concat(entryID, " but received ").concat(data.id));
  }
};
exports.validateForm = validateForm;
var _fieldNamesRecursively = function fieldNamesRecursively(fields) {
  var result = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (!fields || !fields.length) {
    return result;
  }
  fields.forEach(field => {
    if (field.type === _constants.FIELD_TYPES.FIELD_GROUP_FIELD || field.type === _constants.FIELD_TYPES.STEP_CONTENT_TYPE) {
      var _field$fields;
      if ((_field$fields = field.fields) !== null && _field$fields !== void 0 && _field$fields.length) {
        return _fieldNamesRecursively(field.fields, result);
      }
    } else if (field.type === _constants.FIELD_TYPES.STEP_TRACKER_FIELD) {
      var _field$steps;
      if ((_field$steps = field.steps) !== null && _field$steps !== void 0 && _field$steps.length) {
        return _fieldNamesRecursively(field.steps, result);
      }
    }
    if (field.fieldName) {
      result.push(field.fieldName);
    }
  });
  return result;
};
var validateUnifiedOrderDataAdapter = data => {
  // Unified Order API (DOMS integration) requires 4 mandatory fields
  // The 4 fields are: firstName, lastName, email, phoneNumber, as stated on:
  // https://github.com/telus/api-platform-unified-order/blob/develop/src/controllers/leadgen.js#L28
  var requiredFields = ['firstName', 'lastName', 'email', 'phoneNumber'];
  var missingFields = [];
  var allFieldNames = _fieldNamesRecursively(data.fields);
  requiredFields.forEach(field => {
    if (!allFieldNames.includes(field)) {
      missingFields.push(field);
    }
  });
  var hasUnifiedOrderAdapter = Array.isArray(data.dataAdapters) && data.dataAdapters.some(adapter => adapter.type === _constants.UNIFIED_ORDER_DATA_ADAPTER);
  if (hasUnifiedOrderAdapter && missingFields.length > 0) {
    _errorHandlerUtility.default.report(JSON.stringify({
      message: "Missing the following required field(s) with or without field group for unified order data adapter: ".concat(missingFields.toString()),
      fileName,
      methodName: 'validateUnifiedOrderDataAdapter'
    }));
    throw new Error("Missing the following required field(s) with or without field group for unified order data adapter: \n\n    ".concat(missingFields.toString(), " \n"));
  }
};
exports.validateUnifiedOrderDataAdapter = validateUnifiedOrderDataAdapter;
var validateMailchimp = data => {
  var _data$dataAdapters;
  var mailchimpDataAdapter = data === null || data === void 0 || (_data$dataAdapters = data.dataAdapters) === null || _data$dataAdapters === void 0 ? void 0 : _data$dataAdapters.find(adapter => adapter.type === _constants.GENERIC_DATA_ADAPTER_TYPE && adapter.endpoint === 'Mailchimp API v-us7');
  var isMailchimp = Array.isArray(data.dataAdapters) && mailchimpDataAdapter;
  if (isMailchimp) {
    var _mailchimpDataAdapter;
    var hasListID = mailchimpDataAdapter === null || mailchimpDataAdapter === void 0 || (_mailchimpDataAdapter = mailchimpDataAdapter.body) === null || _mailchimpDataAdapter === void 0 ? void 0 : _mailchimpDataAdapter.hasOwnProperty('listID');
    if (!hasListID) {
      _errorHandlerUtility.default.report(JSON.stringify({
        message: "Missing list ID required field in Body",
        fileName,
        methodName: 'validateMailchimp'
      }));
      throw new Error("Missing list ID required field in Body");
    }
  }
};
exports.validateMailchimp = validateMailchimp;
var validateCheckboxField = data => {
  data.fields.forEach(field => {
    // For each checkbox field, if it has more than one field option, yet does not have field label
    // it will violate acessibility rule. Only when there is 1 option for the checkbox field, can
    // we allow empty label / legend, for example: using the checkbox field as a consent checkbox
    if (field.type === _constants.FIELD_TYPES.CHECKBOX_FIELD && Array.isArray(field.options) && field.options.length > 1 && field.label === undefined) {
      _errorHandlerUtility.default.report(JSON.stringify({
        message: 'A checkbox field with two or more options MUST have a field label',
        fileName,
        methodName: 'validateCheckboxField'
      }));
      throw new Error('A checkbox field with two or more options MUST have a field label');
    }
  });
};
exports.validateCheckboxField = validateCheckboxField;
var validateAll = (data, entryID) => {
  validateForm(data, entryID);
  validateUnifiedOrderDataAdapter(data);
  validateCheckboxField(data);
  validateMailchimp(data);
};
exports.validateAll = validateAll;
var validationFields = {
  validateForm,
  validateUnifiedOrderDataAdapter,
  validateCheckboxField,
  validateAll,
  validateMailchimp
};
var _default = exports.default = validationFields;